export default {
  data: () => ({
    stripeApiLoaded: false,
    stripeApiLoadingFailed: false
  }),
  mounted() {
    this.importStripeApi()
  },
  methods: {
    importStripeApi() {
      this.$loadScript('https://js.stripe.com/v3/')
        .then(() => {
          this.stripeApiLoaded = true
          this.stripeApiLoadingFailed = false
        })
        .catch(() => {
          // Failed to fetch script
          this.stripeApiLoaded = false
          this.stripeApiLoadingFailed = true
        })
    }
  }
}
